import { render } from "./inwarding.vue?vue&type=template&id=68391ab6"
import script from "./inwarding.vue?vue&type=script&lang=js"
export * from "./inwarding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__